import { oc } from "@orpc/contract";
import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";

const EntityQuickFindInputSchema = z.object({
  search: z.string().min(1).max(200),
});

const EntityQuickFindResultItemSchema = z.object({
  id: z.string(),
  label: z.string(),
  sublabel: z.string().nullable(),
  category: z.nativeEnum(SystemEntity),
  /**
   * Optional parent identifier for entities whose detail route is nested under
   * another record (e.g. a collection thread lives at
   * `/collections/$customerId/threads/$threadId`, so this carries the
   * customerId). Omit for top-level entities navigable by `id` alone.
   */
  parentId: z.string().nullable().optional(),
});

const EntityQuickFindResponseSchema = z.object({
  results: z.array(EntityQuickFindResultItemSchema),
});

export const entityQuickFindContracts = {
  search: oc
    .input(EntityQuickFindInputSchema)
    .output(EntityQuickFindResponseSchema)
    .route({ method: "GET" }),
} as const;

export type EntityQuickFindInput = z.infer<typeof EntityQuickFindInputSchema>;
export type EntityQuickFindResultItem = z.infer<
  typeof EntityQuickFindResultItemSchema
>;
export type EntityQuickFindResponse = z.infer<
  typeof EntityQuickFindResponseSchema
>;
